import { useEffect } from "react";
import {
  getAppBuildVersion,
  getPlatform,
  getWebAppVersion,
} from "utils/config";

const useClarity = () => {
  const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;

  const setUserIdClarity = (userId) => {
    if (projectId) {
      try {
        window.clarity("set", "userId", userId);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const setUserPropertiesClarity = (obj) => {
    if (!obj || typeof obj !== "object") return;
    if (projectId) {
      try {
        Object.entries(obj).forEach(([key, value]) => {
          window.clarity("set", key, String(value));
        });
        window.clarity("set", "app_build", String(getAppBuildVersion()));
        window.clarity("set", "app_version", String(getWebAppVersion()));
        window.clarity("set", "platform", String(getPlatform()));
      } catch (error) {
        console.error("Clarity user properties error:", error);
      }
    }
  };

  useEffect(() => {
    if (projectId) {
      try {
        (function (c, l, a, r, i, t, y) {
          c[a] =
            c[a] ||
            function () {
              (c[a].q = c[a].q || []).push(arguments);
            };
          t = l.createElement(r);
          t.async = 1;
          t.src = "https://www.clarity.ms/tag/" + i;
          y = l.getElementsByTagName(r)[0];
          y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script", projectId);
      } catch (error) {
        console.log(error);
      }
    }
  }, []);
  return {
    setUserIdClarity,
    setUserPropertiesClarity,
  };
};

export default useClarity;
